
export const IS_DEV = import.meta.env.MODE !== "production";

export const NAME_ANIMATION_LIVES = "lives"
export const NAME_ANIMATION_POINTS = "points"

export const NAME_SOUND_INTRO = "intro"
export const NAME_SOUND_ACTIVE_BANK = "activeBank"
export const NAME_SOUND_HOVER = "hover"
export const NAME_SOUND_POINTS = "points"
export const NAME_SOUND_FAILURE = "failure"
export const NAME_SOUND_LIVE = "live"
export const NAME_SOUND_COUNTDOWN = "countdown"
export const NAME_SOUND_WIN = "win"
export const NAME_SOUND_LOSS = "loss"
export const NAME_SOUND_POINTS_COUNT = "pointsCount"
export const NAME_SOUND_FINAL_COUNTDOWN = "finalCountdown"
export const NAME_SOUND_SUCCESS = "success"
export const NAME_SOUND_WRONG = "wrong"
export const NAME_SOUND_ACTIVE = "active"
export const NAME_SOUND_CHARGE = "load"

export const CONTENT_TYPE = {
    AUDIO: "audio",
    IMAGE: "image",
    TEXT: "text",
    YOUTUBE: "youtube",
    ENHANCETEXT: "enhancetext",
}

export const TYPE_QUESTIONS = {
    Text: "text",
    Selection: "selection",
    Information: "information"  
}

export const COLORS = {
    primaryOrigin: "var(--color-primary-origin)",
    primary: "var(--color-primary)",
    primaryDark1: "var(--color-primary-dark-1)",
    primaryDark2: "var(--color-primary-dark-2)",
    primaryDark3: "var(--color-primary-dark-3)",
    primaryDark4: "var(--color-primary-dark-4)",
    primaryDark5: "var(--color-primary-dark-5)",
    primaryDark6: "var(--color-primary-dark-6)",
    primaryDark7: "var(--color-primary-dark-7)",
    primaryLight1: "var(--color-primary-light-1)",
    primaryLight2: "var(--color-primary-light-2)",
    primaryLight3: "var(--color-primary-light-3)",
    primaryLight4: "var(--color-primary-light-4)",
    primaryLight5: "var(--color-primary-light-5)",
    primaryLight6: "var(--color-primary-light-6)",
    primaryLight7: "var(--color-primary-light-7)",
    black: "var(--color-black)",
    grey: "var(--color-grey)",
    white: "var(--color-white)",
    action: "var(--color-action)",
    text: "var(--color-text)",
    textAction: "var(--color-text-action)",
    red: "var(--color-red)",
    redLight1: "var(--color-red-light-1)",
    redLight2: "var(--color-red-light-2)",
    contrast: "var(--color-contrast)",
    green: "var(--color-green)",
    contrastBlackOrigin: "var(--color-contrast-blackOrigin)"
}